export const JSS_SETTINGS = '[JSS] Settings';
export const JSS_DICTIONARY = '[JSS] Dictionary';
export const JSS_STATE = '[JSS] Data';
export const IS_SITECORE_SERVER = '[JSS] Is Sitecore Server';
